
const PricingAndLeadTimesBanner = () => {
  return (
    <div className="alert alert-warning py-1 mt-1 w-100">
      <div className='d-flex align-items-center'>
        <div className='flex-grow-0 me-2'>
          <i className="fa fa-exclamation-circle text-danger" />
        </div>
        <div className='flex-grow-0'>
        Pricing & Lead Times will not be available for products with custom requests until this quote is reviewed.
        </div>
      </div>
    </div>
  );
};

const LeadTimesBanner = () => {
  return (
    <div className="alert alert-warning mt-1 w-100">
      <div className='d-flex align-items-center'>
        <div className='flex-grow-0 me-1'>
          <i className="fa fa-exclamation-circle text-danger" />
        </div>
        <div className='flex-grow-0'>
        Lead Times and Pricing will not be available until quote is reviewed.
        </div>
      </div>
    </div>
  );
};

const PriceBanner = () => {
  return (
    <div className="alert alert-warning py-1 mt-1 w-100">
      <div className='d-flex align-items-center'>
        <div className='flex-grow-0 me-1'>
          <i className="fa fa-exclamation-circle text-danger" />
        </div>
        <div className='flex-grow-0'>
        Total price will not be available until this quote is reviewed.
        </div>
      </div>
    </div>
  );
};
export { PricingAndLeadTimesBanner, PriceBanner, LeadTimesBanner };

